<template>
  <v-dialog
    v-model="showModal"
    persistent
    max-width="700px"
    @keydown.enter.prevent="submit()"
    @keydown.esc.prevent="cancel()"
  >
    <v-card class="modalCard">
      <v-card-title class="modalTitle pt-2 pb-1 mb-2">
        <h2>{{ tabItem.modalLabel }}</h2>
      </v-card-title>
      <v-card-text class="pt-2 pb-2">
        <v-card class="mb-2">
          <v-card-text class="mb-0 pb-0">
            <v-row class="mb-3">
              <v-col cols="12" md="6">
                <el-date-picker
                  required
                  label="Laikotarpio data nuo"
                  tooltip="Ataskaita. Registrai. Modal. Laikotarpio data nuo"
                  v-model="ata_laikotarpis_data_nuo"
                />
              </v-col>
              <v-col cols="12" md="6">
                <el-date-picker
                  required
                  label="Laikotarpio data iki"
                  tooltip="Ataskaita. Registrai. Modal. Laikotarpio data iki"
                  v-model="ata_laikotarpis_data_iki"
                />
              </v-col>
              <template v-if="isRegistrams">
                <v-col cols="12" md="6">
                  <el-time-picker
                    required
                    label="Laikotarpio laikas nuo"
                    tooltip="Ataskaita. Registrai. Modal. Laikotarpio laikas nuo"
                    v-model="ata_laikotarpis_laikas_nuo"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <el-time-picker
                    required
                    label="Laikotarpio laikas iki"
                    tooltip="Ataskaita. Registrai. Modal. Laikotarpio laikas iki"
                    v-model="ata_laikotarpis_laikas_iki"
                  />
                </v-col>
                <v-col cols="12" md="12">
                  <el-autocomplete
                    required
                    :items="registrasTipasList"
                    itemvalue="value"
                    itemtext="text"
                    label="Susijusio registro objektas"
                    tooltip="Ataskaita. Registrai. Modal. Susijęs registras"
                    v-model="ata_tipas"
                  />
                </v-col>
              </template>
            </v-row>
          </v-card-text>
        </v-card>
      </v-card-text>
      <v-card-actions class="modalActions" elevation="5">
        <v-spacer></v-spacer>
        <el-button :loading="loading" @click.native.stop="closeModal()">
          Atšaukti
        </el-button>
        <el-button :loading="loading" primary @click.native="saveData()">
          Saugoti
        </el-button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import registrasTipasList from '../ataskaita/registrasTipasList'

export default {
  name: 'ModalAtaskaita',
  props: {
    value: Boolean,
    tabItem: Object,
  },
  mixins: [registrasTipasList],
  data() {
    return {
      loading: false,

      ata_laikotarpis_data_nuo: null,
      ata_laikotarpis_data_iki: null,
      ata_laikotarpis_laikas_nuo: '00:00',
      ata_laikotarpis_laikas_iki: '23:59',
      ata_tipas: null,
    }
  },
  $_veeValidate: {
    validator: 'new',
  },
  computed: {
    showModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isRegistrams() {
      return this.tabItem.registrams
    },
  },
  created() {
    //
  },
  methods: {
    saveData() {
      this.$validator.validateAll().then(res => {
        if (res) {
          this.loading = true

          const data = {
            ata_laikotarpis_data_nuo: this.ata_laikotarpis_data_nuo,
            ata_laikotarpis_data_iki: this.ata_laikotarpis_data_iki,
            ata_laikotarpis_laikas_nuo: this.ata_laikotarpis_laikas_nuo,
            ata_laikotarpis_laikas_iki: this.ata_laikotarpis_laikas_iki,
            ata_tipas: this.isRegistrams ? this.ata_tipas : this.tabItem.tipas,
          }
          this.$axios
            .post(`ataskaita/ataskaita`, data)
            .then(res => {
              window._VMA.$emit('DATA_OK', res.data.message)

              this.$emit('savedData')
              this.closeModal()
            })
            .catch(err => {
              window._VMA.$emit('DATA_ERROR', err.response.data.message)
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          window._VMA.$emit('FORMAT_ERROR')
        }
      })
    },
    closeModal() {
      this.showModal = false
    },
    submit() {
      this.saveData()
    },
    cancel() {
      this.closeModal()
    },
  },
}
</script>
<style lang="scss" scoped>
.modalCard {
  background: #f5f5f5 !important;
}
.modalTitle {
  background: #f5f5f5 !important;
  position: sticky;
  top: 0;
  z-index: 2;
  background: none;
  border-bottom: thin solid rgba(0, 0, 0, 0.12);
}
.modalActions {
  position: sticky;
  bottom: 0;
  z-index: 1;
}
</style>
